import { ORM } from "redux-orm";

import { Project, GeoData, Comment, Completion, User, Organisation, TimeReport } from "./models";
import { RootState } from "./bootstrap";


// Define ORM DB schema
const schema = {Project, GeoData, Comment, Completion, User, Organisation, TimeReport};
export type Schema = typeof schema;

// Define ORM instance
const orm = new ORM<Schema>({
    // .orm refers to wherever the reducer is put during createStore
    stateSelector: (state: RootState) => state.orm 
});

// Register used DB Models on ORM 
orm.register(Project, GeoData, Comment, Completion, User, Organisation, TimeReport);

export default orm;

